import { render } from "./AddConfigServerEditorData.vue?vue&type=template&id=46abc8cc&scoped=true"
import script from "./AddConfigServerEditorData.vue?vue&type=script&lang=js"
export * from "./AddConfigServerEditorData.vue?vue&type=script&lang=js"

import "./AddConfigServerEditorData.vue?vue&type=style&index=0&id=46abc8cc&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46abc8cc"]])

export default __exports__